<template>
  <div class="app-container">
    <el-card class="box-card">
      <div slot="header" class="clearfix">
        <span><i class="el-icon-money"></i> 结余记录</span>
      </div>

      <!-- 搜索区域 -->
      <el-form
        :model="queryParams"
        :inline="true"
        label-position="right"
        class="demo-form-inline"
        style="margin-bottom: 20px"
      >
            <el-form-item label="物资名称">
              <el-input
                v-model="queryParams.name"
                placeholder="请输入物资名称"
                clearable
                style="width: 260px"
              />
            </el-form-item>
        <el-row>
          <el-button
            type="primary"
            icon="el-icon-search"
            @click="handleQuery(1)"
            >搜索</el-button
          >
          <el-button @click="resetQuery">重置</el-button>
          <el-button @click="exportExcel">导出</el-button>
        </el-row>
      </el-form>

      <el-table
        :data="tableData"
        style="width: 100%"
        border
        :cell-style="{ textAlign: 'center' }"
        :header-cell-style="{
          background: '#f5f7fa',
          color: '#333',
          fontWeight: 'bold',
          textAlign: 'center',
        }"
      >
        <el-table-column prop="categoryName" label="食品类别" />
        <el-table-column prop="name" label="物资名称" />
        <el-table-column prop="currentNum" label="库存数量" />
        <el-table-column prop="singlePrice" label="单价" />
        <el-table-column prop="totalAmount" label="合计" />
      </el-table>

      <!-- 分页 -->
      <pagination-bar
        :total="total"
        :page-size="pageSize"
        :current-page="currentPage"
        @update:pageSize="pageSize = $event"
        @update:currentPage="currentPage = $event"
        @page-change="handleQuery"
      />
    </el-card>
  </div>
</template>

<script>
import { foodRecordDetail, balanceExcelDataList } from "@/api/material";
import PaginationBar from "@/components/PaginationBar";
import { downloadFile } from "@/utils/util";

export default {
  name: "MoneyRecord",
  components: { PaginationBar },
  data() {
    return {
      queryParams: {
        name: "",
      },
      pageSize: 10,
      currentPage: 1,
      total: 0,
      tableData: [],
    };
  },
  created() {
    this.handleQuery();
  },
  methods: {
    handleQuery(page) {
      this.currentPage = page || 1;
      foodRecordDetail({
        pageNo: this.currentPage,
        pageSize: this.pageSize,
        ...this.queryParams,
      }).then((res) => {
        this.tableData = res.records;
        this.total = res.total;
      });
    },
    resetQuery() {
      this.queryParams = {
        name: "",
      };
      this.currentPage = 1;
      this.handleQuery();
    },
    exportExcel() {
      balanceExcelDataList({
        pageNo: this.currentPage,
        pageSize: this.pageSize,
        ...this.queryParams,
      }).then((res) => {
        downloadFile(
          res.data,
          "结余记录.xlsx",
          "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
        );
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.app-container {
  
}
</style>
